'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import { getCmsPageLink } from '../../../app/[site]/[locale]/(cms)/_modules/routing';
import { pushDataLayer } from '../pushDataLayer';
import { CONTENT_MHG } from '../translations/mhg';
import { ArticleAuthor } from '$/(cms)/_modules/cmsService/types';
import { FeLink } from '$/components/FeLink';
import { useClientContext } from '$/modules/context/client';

export const AuthorSimple: React.FC<{
  index: number;
  author: ArticleAuthor;
}> = ({ index, author }) => {
  const { lang, brand, langPrefix } = useClientContext();
  const staticText = CONTENT_MHG.get(lang);
  const authorHref = author.slug
    ? getCmsPageLink({
        brand,
        pageType: 'author',
        slug: author.slug,
        langPrefix,
      })
    : undefined;

  const handleAuthorClick = () => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'body',
      component_title: `Article Author_${author.name}`,
      action: 'click',
      index: index,
    });
  };

  return (
    <div className="flex items-center gap-3">
      {author.avatar?.url && authorHref && (
        <FeLink
          href={authorHref}
          className="size-12 overflow-hidden rounded-full"
          onClick={handleAuthorClick}
        >
          <CmsImage
            height={48}
            width={48}
            sizes={{ _: 48 }}
            className="object-contain"
            src={author.avatar?.url}
            alt={author.name!}
          />
        </FeLink>
      )}
      {author.avatar?.url && !authorHref && (
        <div className="size-12 overflow-hidden rounded-full">
          <CmsImage
            height={48}
            width={48}
            sizes={{ _: 48 }}
            className="object-contain"
            src={author.avatar?.url}
            alt={author.name!}
          />
        </div>
      )}
      <div>
        <h4 className="font-semibold text-base">
          {staticText?.written_by ?? ''}
          {authorHref ? (
            <FeLink
              href={authorHref}
              className="ml-1 underline text-primary"
              onClick={handleAuthorClick}
            >
              {author.name}
            </FeLink>
          ) : (
            <span className="ml-1">{author.name}</span>
          )}
        </h4>
        <p className="font-medium text-gray-700 text-sm ">{author.position}</p>
      </div>
    </div>
  );
};
